import React, { Component } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { name, storageKeys } from 'settings';
import { BackImage, StorageHandler, LanguageSelect, MiniChat } from 'C4';

import logo from 'assets/images/logo/logo_white.png';

export default class ProfileView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: ''
    };

  }

  async componentWillMount() {
    this.setUserOnline();
  }

  async setUserOnline() {
    try {
      const user = await StorageHandler.load(storageKeys.user);
      if (user) {
        const { id } = this.props.match.params;
        const { email } = user.response;
        this.setState({ email });
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {

  }

  // TODO firebase set data
  render() {
    return (
      <div className="profileView">
        <iframe
          className="standPage"
          src="https://travproconnect.com/profile_booth/88?app_id=600"
        />
        <style>{'\
        #openWidget { display: none; bottom: 3rem; } '}
        </style>
        <MiniChat className="miniChat" />
      </div>
    );
  }
}
